import {RouteConfig} from "vue-router";
const ShopList = () => import('../views/shop/ShopList.vue');

let shop: RouteConfig[] = [
    {
        name: 'shop',
        path: '/shop',
        component: ShopList,
        meta: {
            allowLoggedOut: true,
        },
    },
];

export default shop;
